import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   elements: [],
   newest: '',
   count: 0,
   play: false
}

export const focusSlice = createSlice({
    name: 'focus',
    initialState,
    reducers: {
        //exchanges the focusitem if newer
        //payload is an array
        add: (state, action) => {
            switch (state.newest) {
                case '':
                    if (state.elements.length > 0) {
                        state.elements.pop();
                    }
                    var payloadSorted = action.payload.slice().sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
                    state.elements = payloadSorted;
                    state.count+=payloadSorted.length;
                    state.newest=payloadSorted[0].updatedAt;
                    break;
            
                default:
                    var payloadSortedD = action.payload.slice().sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
                    for (let index = 1; index === payloadSortedD.length; index++) {
                        if (state.elements.length === 0) {
                            state.elements[0] = payloadSortedD[payloadSortedD.length-index];
                        }
                        //check if id of new element is same as last newest id in focus stack. if yes replace, if no push back and insert element before
                        else if (payloadSortedD[payloadSortedD.length-index].id === state.elements[0].id) {
                            state.elements[0] = payloadSortedD[payloadSortedD.length-index];
                        } else {
                            state.elements.splice(0, 0, payloadSortedD[payloadSortedD.length-index]);
                        }
                    }
                    state.count+=payloadSortedD.length;
                    state.newest=payloadSortedD[0].updatedAt;
                    state.play=true;
                    break;
            }
        },
        fire: ( state ) => {
            if (state.play) {
                const dateObj = new Date();
                let timeNow = dateObj.getTime()
                let lastIndex = state.elements.length-1;
                console.log('Fired with index '+lastIndex+' and time '+timeNow);
                let i = lastIndex;
                while (i>=0) {
                    console.log('For loop-');
                    let timeDelta = timeNow - Date.parse(state.elements[i].updatedAt);
                    console.log(timeDelta);
                    if (timeDelta < 30000) {
                        break;
                    } else {
                        console.log('Focus -> killed element with id '+state.elements[i].id+' on index '+i);    
                        state.elements.splice(i, 1);
                    }
                    i-=1;
                }
                //console.log (lastIndex+' : '+Date.parse(state.elements[0].updatedAt)+' : '+time);
                
            }
        }
    }
})

export const { add, fire } = focusSlice.actions;

export const selectFocus = (state) => state.focus;

export default focusSlice.reducer;